import React from 'react';
import { Link } from 'react-router-dom';
import ImplantCenterLayout from './ImplantCenterLayout';

const DentalPlan = () => {
  return (
    <ImplantCenterLayout
      title="Affordable Dental Plan Fort Worth TX | $199/Year | Fort Worth Dental Implant Center"
      description="Fort Worth Dental's affordable dental plan - only $199/year. 20% off all procedures, free cleanings, exams, and X-rays. No insurance needed. Dental implant financing available. Call (817) 854-4329."
      keywords="dental plan fort worth, affordable dentist fort worth tx, dental financing, no insurance dentist, dental savings plan, dental implant financing"
    >
      {/* Hero */}
      <section className="relative py-20 bg-gradient-to-br from-teal-700 to-teal-900">
        <div className="relative container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Fort Worth Dental Provides A Dental Plan You Can Afford
          </h1>
          <p className="text-xl text-teal-100 mb-8 max-w-3xl mx-auto">
            Quality dental care shouldn't break the bank. Our in-house dental plan makes comprehensive dental care accessible to everyone.
          </p>
          <div className="inline-block bg-white rounded-xl p-8 shadow-2xl">
            <p className="text-teal-600 font-semibold text-lg">Annual Membership</p>
            <p className="text-6xl font-bold text-gray-800">$199<span className="text-2xl text-gray-500">/year</span></p>
            <p className="text-gray-600 mt-2">Per individual</p>
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">What's Included in Your Dental Plan?</h2>
            
            <div className="bg-teal-50 rounded-xl p-8 mb-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">FREE Services (100% Covered)</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-center space-x-3">
                  <span className="text-teal-600 text-2xl">✓</span>
                  <span className="text-gray-700">2 Professional Cleanings per year</span>
                </div>
                <div className="flex items-center space-x-3">
                  <span className="text-teal-600 text-2xl">✓</span>
                  <span className="text-gray-700">2 Comprehensive Exams per year</span>
                </div>
                <div className="flex items-center space-x-3">
                  <span className="text-teal-600 text-2xl">✓</span>
                  <span className="text-gray-700">Necessary X-Rays</span>
                </div>
                <div className="flex items-center space-x-3">
                  <span className="text-teal-600 text-2xl">✓</span>
                  <span className="text-gray-700">1 Emergency Exam per year</span>
                </div>
              </div>
            </div>

            <div className="bg-purple-50 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">20% OFF All Other Procedures</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <ul className="space-y-2 text-gray-700">
                  <li>• Dental Implants</li>
                  <li>• Crowns & Bridges</li>
                  <li>• Root Canals</li>
                </ul>
                <ul className="space-y-2 text-gray-700">
                  <li>• Teeth Whitening</li>
                  <li>• Fillings</li>
                  <li>• Extractions</li>
                </ul>
                <ul className="space-y-2 text-gray-700">
                  <li>• Dentures</li>
                  <li>• LANAP Treatment</li>
                  <li>• And more...</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Why Choose Our Plan Over Insurance?</h2>
            <div className="overflow-x-auto">
              <table className="w-full bg-white rounded-xl shadow-lg overflow-hidden">
                <thead className="bg-teal-600 text-white">
                  <tr>
                    <th className="py-4 px-6 text-left">Feature</th>
                    <th className="py-4 px-6 text-center">Our $199 Plan</th>
                    <th className="py-4 px-6 text-center">Traditional Insurance</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr>
                    <td className="py-4 px-6 font-medium">Annual Cost</td>
                    <td className="py-4 px-6 text-center text-teal-600 font-bold">$199</td>
                    <td className="py-4 px-6 text-center">$300-$600+</td>
                  </tr>
                  <tr className="bg-gray-50">
                    <td className="py-4 px-6 font-medium">Waiting Periods</td>
                    <td className="py-4 px-6 text-center text-teal-600 font-bold">None</td>
                    <td className="py-4 px-6 text-center">6-12 months</td>
                  </tr>
                  <tr>
                    <td className="py-4 px-6 font-medium">Annual Maximums</td>
                    <td className="py-4 px-6 text-center text-teal-600 font-bold">None</td>
                    <td className="py-4 px-6 text-center">$1,000-$2,000</td>
                  </tr>
                  <tr className="bg-gray-50">
                    <td className="py-4 px-6 font-medium">Deductibles</td>
                    <td className="py-4 px-6 text-center text-teal-600 font-bold">None</td>
                    <td className="py-4 px-6 text-center">$50-$100</td>
                  </tr>
                  <tr>
                    <td className="py-4 px-6 font-medium">Claim Forms</td>
                    <td className="py-4 px-6 text-center text-teal-600 font-bold">None</td>
                    <td className="py-4 px-6 text-center">Required</td>
                  </tr>
                  <tr className="bg-gray-50">
                    <td className="py-4 px-6 font-medium">Pre-approvals</td>
                    <td className="py-4 px-6 text-center text-teal-600 font-bold">Not needed</td>
                    <td className="py-4 px-6 text-center">Often required</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Financing Options */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Flexible Financing Options</h2>
            <p className="text-gray-700 text-lg text-center mb-8">
              For larger treatments like dental implants, we offer flexible financing through trusted partners:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white border-2 border-gray-200 rounded-xl p-6 text-center">
                <h3 className="text-2xl font-bold text-gray-800 mb-2">CareCredit</h3>
                <p className="text-gray-600 mb-4">Healthcare financing with promotional 0% APR options</p>
                <p className="text-teal-600 font-semibold">6, 12, 18, or 24 month plans</p>
              </div>
              <div className="bg-white border-2 border-gray-200 rounded-xl p-6 text-center">
                <h3 className="text-2xl font-bold text-gray-800 mb-2">Lending Club</h3>
                <p className="text-gray-600 mb-4">Patient financing with fixed monthly payments</p>
                <p className="text-teal-600 font-semibold">Affordable monthly payments</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-teal-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Start Saving on Your Dental Care Today</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Join our dental plan and start receiving quality dental care at affordable prices.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a href="tel:8178544329" className="bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-bold hover:bg-gray-100 transition">
              Call (817) 854-4329
            </a>
            <Link to="/implant-center#consultation-form" className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-teal-500 transition">
              Sign Up Today
            </Link>
          </div>
        </div>
      </section>
    </ImplantCenterLayout>
  );
};

export default DentalPlan;
